import mapboxgl from 'mapbox-gl'
import styled from 'styled-components'
import { Fragment, useContext, useEffect } from 'react'
import { MapAnnotation } from 'components/Mapbox/Types/mapboxtypes'
import { MapContext } from 'components/Mapbox/Mapbox'
import { createRoot } from 'react-dom/client'
import { UITooltip } from '../UITooltip/UITooltip'
const currentMarkers: mapboxgl.Popup[] = []

export const Annotations = ({
  annotations,
  hidePointer = false,
  pointerColor,
}: {
  annotations: MapAnnotation[]
  hidePointer?: boolean
  pointerColor?: string
}) => {
  var context = useContext(MapContext)
  var { map, changeDefault } = context
  useEffect(() => {

    if (!context.map) return

    removeAllMarkers()
    annotations.forEach((anno) => {
      const placeholder = document.createElement('div')
      placeholder.className = 'annotation-placeholder'

      createRoot(placeholder).render(<>{anno.element}</>)

      if (!map) return

      const popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false,
      })
        .setLngLat(anno.pos)
        .setDOMContent(placeholder)
        .addTo(map)

      currentMarkers.push(popup)
    })
  }, [annotations, map])

  useEffect(() => {
    changeDefault &&
      changeDefault('pointerColor', hidePointer ? 'transparent' : pointerColor)
  }, [pointerColor, hidePointer, changeDefault, map])

  return <AnnotationLayerComponent annotations={annotations} />
}

export const AnnotationLayerComponent = ({
  annotations,
}: {
  annotations: any[]
}) => {
  return (
    <HiddenStyledComponentForceCSSInjection>
      {annotations &&
        annotations.map((m: MapAnnotation, i) => (
          <Fragment key={'annotation_' + i}>{m.element}</Fragment>
        ))}
    </HiddenStyledComponentForceCSSInjection>
  )
}

function removeAllMarkers() {
  currentMarkers.forEach((m) => m.remove())
  currentMarkers.length = 0
}

const HiddenStyledComponentForceCSSInjection = styled.div`
  display: none;
  pointer-events: none;
`
